"use client";
import { useState, useEffect } from "react";
import Link from "next/link";
import { Box } from "@dxp-feed/ui/Box";
import { Text } from "@dxp-feed/ui/Text";
import { Container } from "@dxp-feed/ui/Container";
import { BINDING_CONFIG } from "@/utils/constants";
const currentYear = new Date().getFullYear();
interface FooterProps {
  FooterData: any;
  bindedDomain: keyof typeof BINDING_CONFIG;
}
export const Footer: React.FC<FooterProps> = ({ FooterData }) => {
  const [footerMenu, setFooterMenu] = useState<any[]>([]);
  const [footerCopyright, setfooterCopyright] = useState<string>();
  useEffect(() => {
    if (FooterData?.data?.centralLoginHeaderFooterList?.items[0]?.footerMenu) {
      setFooterMenu(
        FooterData.data.centralLoginHeaderFooterList.items[0].footerMenu,
      );
    }
    const rawHtml =
      FooterData?.data?.centralLoginHeaderFooterList?.items[0].copyright
        ?.html || "";
    const cleanedHtml = rawHtml.replace(/<\/?(p|span)[^>]*>/g, "");
    setfooterCopyright(cleanedHtml);
  }, [FooterData]);

  return (
    <footer className="bg-brandSecondary py-10  text-white text-body w-full mt-auto">
      <Container className="!max-w-[1536px] w-full 2md:px-12 px-6 md:flex md:flex-row flex-col  justify-between">
        {footerMenu.length > 0 && (
          <Box as="div" className="flex md:flex-row flex-col gap-2">
            {footerMenu.map((item: any, indx: number) => (
              <Link
                className="underline"
                key={`footer-${indx}`}
                href={item.externalUrlLink}
              >
                {item.title}
              </Link>
            ))}
          </Box>
        )}
        <Box as="div" className="md:mt-0 mt-4">
          <Text as="p">{footerCopyright}</Text>
        </Box>
      </Container>
    </footer>
  );
};

// Layout Component
export const Layout = ({ children }: { children: React.ReactNode }) => {
  return (
    <div className="min-h-screen flex flex-col">
      <main className="flex-1">{children}</main>
      <Footer FooterData={""} bindedDomain={"dxp-sobeys"} />
    </div>
  );
};
